import {
	useRouteMatch, Route, Switch
} from 'react-router';
import { urls } from '../../../Constants';
import ProcessThresholdListPage from '../../../Pages/Food Products/ProcessThreshold/ProcessThresholdListPage';

const getSubURL = (entity) => {
	const baseEntity = urls.PROCESS_THRESHOLD;
	return entity.slice(baseEntity.length);
};

const ProcessThresholdRoutes = () => {
	const { path } = useRouteMatch();
	return (
		<Switch>
			<Route exact path={`${path}${getSubURL(urls.PROCESS_THRESHOLD)}`}>
				<ProcessThresholdListPage />
			</Route>
		</Switch>
	);
};

export default ProcessThresholdRoutes;
